module.exports = __webpack_public_path__ + "static/red_abishai-716d7757e4a7b803890afa090fee2a43.png";